Object.defineProperty(exports, "__esModule", { value: true });
var react_router_1 = require("react-router");
window['_history'] = react_router_1.browserHistory;
exports.default = window['_history'];
